import React, { useState } from 'react';
import { Lock } from 'lucide-react';
import authService from '../../services/auth.js';
import RequestAccessModal from './RequestAccessModal.jsx';

const FEATURE_LABELS = {
  panel:     'QuestDB / MySQL Panels',
  scada:     'SCADA Panels',
  reports:   'Reports',
  sharing:   'Dashboard Sharing',
  alarms:    'Alarms',
  templates: 'Report Templates'
};

export default function LockedFeature({ feature, children, badge = true }) {
  const [showModal, setShowModal] = useState(false);
  const unlocked = authService.hasFeature(feature);

  if (unlocked) return children;

  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowModal(true);
  };

  return (
    <>
      <span
        onClick={onClick}
        onMouseDown={(e) => e.stopPropagation()}
        style={{
          position: 'relative',
          display: 'inline-flex',
          cursor: 'pointer'
        }}
        title={`${FEATURE_LABELS[feature] || feature} is locked — click to request access`}
      >
        <span style={{ pointerEvents: 'none', opacity: 0.55, filter: 'grayscale(0.4)' }}>
          {children}
        </span>
        {badge && (
          <span style={{
            position: 'absolute',
            top: -4,
            right: -4,
            width: 16,
            height: 16,
            borderRadius: '50%',
            background: '#1f2937',
            border: '1px solid #374151',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fbbf24',
            pointerEvents: 'none'
          }}>
            <Lock size={9} />
          </span>
        )}
      </span>
      {showModal && (
        <RequestAccessModal
          feature={feature}
          featureLabel={FEATURE_LABELS[feature] || feature}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
}
